export const MuiDivider = {
  styleOverrides: {
    root: {
      height: '1px',
    },
  },
};
